// extracted by mini-css-extract-plugin
export default {"container":"r5-z","list":"s5-z"};